import axios, {AxiosResponse} from 'axios'
import {FranchiseInvoiceLogsQueryResponse, FranchiseInvoiceQueryResponse} from './_models'
import {
  creditCard,
  creditCardResponse,
  franchiseInvoice,
  TremoveCreditCard,
} from '../../../core/_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const FRANCHISEINVOICE_URL = `${API_URL}/franchises`

const getFranchiseInvoice = (
  query: string,
  franchiseId: number
): Promise<FranchiseInvoiceQueryResponse> => {
  return axios
    .get(`${FRANCHISEINVOICE_URL}/${franchiseId}/invoices?${query}`)
    .then((d: AxiosResponse<FranchiseInvoiceQueryResponse>) => d.data)
}

const getInvoice = (id: number, franchiseId: number): Promise<franchiseInvoice> => {
  return axios
    .get(`${FRANCHISEINVOICE_URL}/${franchiseId}/invoices/${id}`)
    .then((d) => d.data)
    .then((d) => d.data)
}

const getCreditCards = (franchiseId: number): Promise<creditCardResponse[]> => {
  return axios
    .get(`${FRANCHISEINVOICE_URL}/${franchiseId}/credit-cards`)
    .then((d) => d.data)
    .then((d) => d.data)
}

const createCreditCard = (franchiseId: number, data: creditCard): Promise<creditCard> => {
  return axios
    .post(`${FRANCHISEINVOICE_URL}/${franchiseId}/credit-cards`, data)
    .then((d) => d.data)
    .then((d) => d.data)
}

const updateCreditCard = (franchiseId: number, cardId: number): Promise<creditCard> => {
  return axios
    .patch(`${FRANCHISEINVOICE_URL}/${franchiseId}/credit-cards/${cardId}/favorite`)
    .then((d) => d.data)
}

const changeCreditCard = (
  franchiseId: number,
  creditCardId: number,
  data: creditCard
): Promise<creditCard> => {
  return axios
    .post(`${FRANCHISEINVOICE_URL}/${franchiseId}/credit-cards`, data)
    .then((d) => d.data)
    .then((d) => d.data)
}

const removeCreditCard = (
  franchiseId: number,
  creditCardId: number
): Promise<TremoveCreditCard> => {
  return axios
    .delete(`${FRANCHISEINVOICE_URL}/${franchiseId}/credit-cards/${creditCardId}`)
    .then((d) => d.data)
}

const getFranchiseInvoiceLogs = (
  query?: string,
  franchiseId?: number,
  invoiceId?: number
): Promise<FranchiseInvoiceLogsQueryResponse> => {
  const url = `${FRANCHISEINVOICE_URL}/${franchiseId}/invoices/${invoiceId}/logs?${query}`

  return axios.get(url).then((d: AxiosResponse<FranchiseInvoiceLogsQueryResponse>) => d.data)
}

const downloadFilePDF = async (
  filter: number,
  franchiseId: number
): Promise<{id: number; franchiseId: number} | void> => {
  const response = await axios({
    url: `${FRANCHISEINVOICE_URL}/${franchiseId}/invoices/${filter}/pdf`,
    method: 'GET',
    responseType: 'blob',
  })

  const contentType = response.headers['content-type'] ?? ''

  if (contentType.includes('application/json')) {
    const text = await (response.data as Blob).text()
    return JSON.parse(text) as {message: string; id: number; franchiseId: number}
  }

  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', 'Historico_fatura.pdf')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export {
  getFranchiseInvoice,
  getInvoice,
  getCreditCards,
  createCreditCard,
  removeCreditCard,
  changeCreditCard,
  getFranchiseInvoiceLogs,
  updateCreditCard,
  downloadFilePDF,
}
